// also have a first click event option, each tp should have options on event depending on the placement or preference from mockup/dev

export function tabEvents() {
	const tabs = document.querySelectorAll(".ilawyer-tabs");
	if (!tabs.length) return;

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				obs.unobserve(entry.target);

				// one-off async import + init
				(async () => {
					try {
						const { initTabs } = await import("./tabs.js");
						initTabs(entry.target);
					} catch (err) {
						console.error("Failed to load module:", err);
					}
				})();
			});
		},
		{ threshold: 0.1 }
	);

	tabs.forEach((tab) => observer.observe(tab));
}
